import { appConfig } from "../../config";

export const apiUrl = appConfig.apiHost || "https://admin.stripperfans.com/api/user/";
export const socket_face2face_url = appConfig.f2fSocketHost

export const apiConstants = {
  // Common variables

  LOGIN_BY: "manual",

  DEVICE_TYPE: "web",

  DEVICE_TOKEN: "123456",

  // Social Login Credentials

  GOOGLE_CLIENT_ID: "",

  FACEBOOK_APP_ID: "",

  ERROR_CODE: [1000, 1001, 1002, 1003, 1004, 1005, 1006],

  settingsUrl: `${apiUrl}get_settings_json`
};
